<template>
  <v-menu
    ref="menu"
    v-model="menu"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="date.format('YYYY/MM/DD')"
        readonly
        class="input"
        v-on="on"
      />
    </template>
    <v-date-picker
      :value="date.format(format)"
      full-width
      no-title
      prev-icon="mdi-arrow-left-drop-circle"
      next-icon="mdi-arrow-right-drop-circle"
      :day-format="dayFormat"
      locale="ja-JP"
      :max="new Date().toLocaleDateString('ja-JP').split('/').join('-')"
      :allowed-dates="allowedDates"
      @input="update"
    />
  </v-menu>
</template>
<script>
import * as moment from 'moment'

export default {
  props: {
    label: {
      type: String,
      default: () => null
    },
    value: {
      type: Number,
      default: () => moment().unix()
    },
    format: {
      type: String,
      default: () => 'YYYY-MM-DD'
    },
    min: {
      type: Number,
      default: () => null
    },
    max: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    date () {
      return moment.unix(this.value)
    }
  },
  methods: {
    update (val) {
      this.$emit('input', val)
      this.menu = false
    },
    dayFormat (value) {
      return parseInt(value.substring('YYYY-MM-'.length), 10)
    },
    allowedDates (val) { // min/max に応じて選択可能なDateを返す
      const calenderFullDate = val.split('-')
      const calenderDay = Number(calenderFullDate.pop())

      const fullToday = new Date().toLocaleDateString('ja-JP').split('/')
      const today = Number(fullToday.pop())
      // '8' -> '08', '12' -> '12'
      fullToday[1] = ('0' + fullToday[1]).slice(-2)

      // 今日と同じ年月の場合明日以降は選べない
      if (calenderFullDate.join('') === fullToday.join('') && calenderDay > today) {
        return false
      }

      let biggerThanMin = true
      let smallerThanMax = true
      // 「期間開始」は「期間終了」より後は選べない
      if (this.min) {
        biggerThanMin = this.min <= moment(val, this.format).unix()
      }
      // 「期間終了」は「期間開始」より後は選べない
      if (this.max) {
        smallerThanMax = moment(val, this.format).unix() <= this.max
      }
      return biggerThanMin && smallerThanMax
    }
  }
}
</script>
<style lang="scss" scoped>
.v-picker {
  padding: 12px 12px 0;
  border-radius: 10px;

  &.v-picker--date.theme--light /deep/ {
    .v-date-picker-header .v-btn--icon .v-btn__content {
      color: rgba(0, 0, 0, .54);
    }
    .v-date-picker-table{
      height: auto;
      padding-bottom: 10px;

      &.v-date-picker-table--date, .v-date-picker-table.v-date-picker-table--month  {
        .v-btn {
          width: 41px;
          height: 41px;
          padding-left: 0;
          padding-right: 0;
          &:not(.v-btn--disabled) {
            .v-btn__content {
              color: black;
            }
          }
        }
      }
    }
  }
}
.input /deep/ input {
  cursor: pointer;
}
/deep/ .v-text-field>.v-input__control>.v-input__slot {
  cursor: pointer;
}
</style>
